import { IdentityTeamAri } from '@atlassian/ari';

export function toTeamAri(teamId: string): string {
	try {
		if (IdentityTeamAri.check(teamId)) {
			return teamId;
		}
		return IdentityTeamAri.create({ teamId }).toString();
	} catch {
		return teamId;
	}
}
